import React, { useState } from "react";

const Perform2023AgendaSection = ({ data }) => {

    const [checkTrigger, setCheckTrigger] = useState(0);

    const triggerOpen = (val) => {
        setCheckTrigger(val);
    }

    return (
        <div className="cp-perform2023Agenda">
            <div className="cp-perform2023Agenda__inner l--flex" data-aos="fade-up">
                <div className="cp-perform2023Agenda__left">
                    {data.perform23AgendaSectionAccordion &&
                        <>
                            {data.perform23AgendaSectionAccordion.map((accordion, index) => (
                                <div key={index} className={`${checkTrigger === index ? "is-active" : "is-active"}`}>
                                    {/* ${checkTrigger === index ? "is-active" : "not-active"} use this for accordion to work later */}
                                    {accordion.day &&
                                        <button onClick={() => triggerOpen(index)}>
                                            <span className="l-day">{accordion.day}</span>
                                            <span className="l-date">{accordion.date}</span>
                                        </button>
                                    }
                                    {accordion.events &&
                                        <>
                                            <div className="l-agendaTopics">
                                                {accordion.events.map((topics, index) => (
                                                    <span key={index} dangerouslySetInnerHTML={{ __html: topics.eventName }} />
                                                ))}
                                            </div>
                                        </>
                                    }
                                </div>
                            ))}
                        </>
                    }
                    {data.perform23AgendaSectionButton &&
                        <div className="l-buttonWrap l--mobile">
                            <a className="l-button" href={data.perform23AgendaSectionButton.url} target={data.perform23AgendaSectionButton.target}>{data.perform23AgendaSectionButton.title}</a>
                        </div>
                    }
                </div>
                <div className="cp-perform2023Agenda__right">
                    {data.perform23AgendaSectionHeader &&
                        <h2>{data.perform23AgendaSectionHeader}</h2>
                    }
                    {data.perform23AgendaSectionButton &&
                        <div className="l-buttonWrap l--desktop">
                            <div className="l-relativeButton">
                                <a className="l-button" href={data.perform23AgendaSectionButton.url} target={data.perform23AgendaSectionButton.target}>{data.perform23AgendaSectionButton.title}</a>
                                <a className="l-button l-backgroundHover" href={data.perform23AgendaSectionButton.url} target={data.perform23AgendaSectionButton.target}>{data.perform23AgendaSectionButton.title}</a>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Perform2023AgendaSection;

